// export const BASE_URL = "https://api.omnicard.co.in:5021/fastagDistributorPortal/api/"; // Prod
export const BASE_URL = "https://uat1.omnicard.co.in/fastagDistributorPortal/api/"; // UAT
// export const BASE_URL = "http://localhost:3001/fastagDistributorPortal/api/"; // LOCAL (do not commit)

export const vehicleClasses = [
  {
    id: 4,
    name: "VC4: Mini commercial vehicle",
    value: "VC4",
    color: "blue",
    description: "Car / Jeep / Van / Tata Ace and similar mini light commercial vehicle",
    tagimage: require('../assets/bluecard.png'),
    card: require('../assets/cardblue.png'),
    cardWebp: require('../assets/images/FASTag_Artworks_VC_4.webp'),
    pdf: require('../assets/sample.pdf')
  },
  {
    id: 5,
    name: "VC5: Light Commercial ",
    value: "VC5",
    color: "orange",
    description: "Light Commercial Vehicle",
    tagimage: require('../assets/orangecard.png'),
    card: require('../assets/cardorange.png'),
    cardWebp: require('../assets/images/FASTag_Artworks_VC_5.webp'),
    pdf: require('../assets/sample.pdf')
  },
  {
    id: 6,
    name: "VC6: 3 axle commercial vehicles",
    value: "VC6",
    color: "yellow",
    description: "Three Axle Commercial Vehicles",
    tagimage: require('../assets/yellow.png'),
    card: require('../assets/cardyellow.png'),
    cardWebp: require('../assets/images/FASTag_Artworks_VC_6.webp'),
    pdf: require('../assets/sample.pdf')
  },
  {
    id: 7,
    name: "VC7: Bus/Truck",
    value: "VC7",
    color: "green",
    description: "Bus / Truck",
    tagimage: require('../assets/greencard.png'),
    card: require('../assets/cardgreen.png'),
    cardWebp: require('../assets/images/FASTag_Artworks_VC_7.webp'),
    pdf: require('../assets/sample.pdf')
  },
  {
    id: 12,
    name: "VC12: 4 to 6 axle",
    value: "VC12",
    color: "violet",
    description: "Heavy Commercial Vehicle",
    tagimage: require('../assets/violetcard.png'),
    card: require('../assets/cardviolet.png'),
    cardWebp: require('../assets/images/FASTag_Artworks_VC_12.webp'),
    pdf: require('../assets/sample.pdf')
  }
]